import { ActionTableColumn } from '@check-list/app/classes/models/action-table-column';
import { MenuItemsData } from '@check-list/core/consts/menu-items-data.const';

export const ActionTableGroup: { [key: string]: ActionTableColumn } = {
  Default: {
    visible: [MenuItemsData.DELETE],
    hidden: [MenuItemsData.SHOW]
  },
  Show: {
    visible: [MenuItemsData.SHOW],
    hidden: []
  },
  Uploadable: {
    visible: [MenuItemsData.SHOW],
    hidden: [
      MenuItemsData.UPLOAD,
      MenuItemsData.OPEN_STORAGE,
      MenuItemsData.DELETE
    ]
  }
};
